import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service'
import { Router } from '@angular/router';
import { modelUsuario } from '../../model/usuario'
import { modelG } from '../../model/g'
import { modelMail } from '../../model/mail'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  theme:string = "";
  errMsg:string = "";
  okMsg:string = "";
  tipoPwd:string = "password";
  tiempoMsg:number = 2100;
  resultado:any;
  usuario:modelUsuario;
  grls:modelG;
  mail:modelMail;
  sysN:string="";
  isAlive:any;
  infoWeb:any;
  bases:any;

  constructor(private dataService: DataService, private router:Router) {
    this.sysN = this.dataService.sN;
    this.tiempoMsg = this.dataService.sTerr;
    this.dataService.infoApp();
    this.dataService.infoWebClient();        
  }

  ngOnInit() {
    this.fnRevisaBD();
  }

  
  fnBasesCargadas(){
    //console.log(this.bases)
  }

  fnRevisaBD(){
      //console.log("Alive?");
      this.dataService.isAlive().subscribe(
                        rows => {   
                                this.isAlive = rows
                                },          
                        error => this.fnSinConexion(error),
                        () => this.fnOk() );      
  }

  fnSinConexion(err){
    console.log(err);
    this.errMsg = "« ERROR: Sin conexión a base de datos! »"
    setTimeout(() => {
       this.ngOnInit(); 
       //console.log("Revisando BD!")
    },10000); 
    
  }

  fnOk(){
    //console.log(this.isAlive[0]);
    try{
      if(this.isAlive[0].vivo){
        this.errMsg="";
        //console.log("Conexión exitosa con BD");
      }
    }
    catch(err){
      console.log(err);
      this.errMsg = "« ERROR: Sin conexión a base de datos! »"
    }
  }
   
  fnMailCargado(){
    //console.log(this.mail);
  }

  fnGrlsCargados(){
    //console.log (this.grls);
    if(this.grls){
      if(this.grls[0]){
        if(this.grls[0].n){
          this.dataService.sN = this.grls[0].n;
          this.sysN = this.grls[0].n;
        }
        if(this.grls[0].we)
          this.dataService.sWe = this.grls[0].we;
        if(this.grls[0].m)
          this.dataService.sM = this.grls[0].m;
        if(this.grls[0].t1)
          this.dataService.sT1 = this.grls[0].t1;
        if(this.grls[0].t2)
          this.dataService.sT2 = this.grls[0].t2;
        if(this.grls[0].wa)
          this.dataService.sWa = this.grls[0].wa;
        if(this.grls[0].di)
          this.dataService.sDi = this.grls[0].di;
        if(this.grls[0].di2)
          this.dataService.sDi2 = this.grls[0].di2;
        if(this.grls[0].terr){
          this.dataService.sTerr = this.grls[0].terr;
          this.tiempoMsg = this.grls[0].terr;
        }
      }
    }
  }

  fnRevelaPassword(txtElement){
    //console.log(txtElement.value);
    this.tipoPwd = "";
  }

  fnTapaPassword(){
    this.tipoPwd = "password";
  }

  fnKeyPress(t, ev){
    //console.log(ev)
    this.errMsg="";
    if (!this.dataService.validKey(t, ev)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else{    
      if(ev.key=="Enter"){
        var u = <HTMLInputElement>document.getElementById("txtUsr");
        var p = <HTMLInputElement>document.getElementById("txtPwd");
        this.fnValidarLogin(u.value, p.value);
      }
      return true;
    }
  }

  fnValidarLogin(u,p){
    //console.log(u);
    //console.log(p);
    if (u.length < 1){
      this.errMsg = "Datos incorrectos!"
      setTimeout(() => {
        this.errMsg = "";
      }, this.tiempoMsg);
      return;
    }
    if (p.length < 1){
      this.errMsg = "Datos incorrectos!"
      setTimeout(() => {
        this.errMsg = "";
      }, this.tiempoMsg);
      return;
    }
    /*  FUNCION PARA LOGIN:
    this.dataService.getLogin(u, CryptoJS.MD5(p).toString()).subscribe(
                          rows => {   
                                  this.resultado = rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnLoginResult(p));  
    */
   this.dataService.getValidaCtoGes(u, p).subscribe(
                          rows => {   
                                  this.resultado = rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnValidaResult(u, p));  

  }

  fnValidaResult(cto, cve){
    console.log(this.resultado);
    if(this.resultado){
      if(this.resultado.length == 0){
        this.errMsg="Contrato y/o monto erroneos!";
        setTimeout(() => {
          this.errMsg =""
        }, this.tiempoMsg); 
        return;      
      }
      else{
        this.dataService.tmpCto = cto;
        this.dataService.tmpCve = this.resultado[0].idSuc;
        this.router.navigate(['home']);
      }
    }
  }

  fnLoginResult(p){
    //console.log(this.resultado);
    if(this.resultado){
      var aux = JSON.stringify(this.resultado[0]);
      if(!aux){
        this.errMsg="Usuario y/o contraseña erroneos!";
        setTimeout(() => {
          this.errMsg =""
        }, this.tiempoMsg); 
        return;       
      }
      if(aux.substring(0,4) == '{"":'){
        this.errMsg="Usuario y/o contraseña erroneos!";
        setTimeout(() => {
          this.errMsg =""
        }, this.tiempoMsg);
        return;
      }
      this.usuario = this.resultado[0];
      var fecId = Date.now();
      this.okMsg = "Bienvenido: " + this.usuario.n;
      sessionStorage.setItem('sisGEPMGesFEC', fecId.toString());
      sessionStorage.setItem('sisGEPMGesCTO', this.usuario.idu);


      setTimeout(() => {
          //--> Si es Administrador ir a Administración
          if(this.usuario.idr==0)
            this.router.navigate(['home']);
          //--> Si es Usuario ir a Home
          else
            this.router.navigate(['home']);
            //--> Usando parametros de navegación:
            //this.router.navigate(['home','']);
      }, 1000);
    }
  }

  fnRecuperarPwd(u){
    this.router.navigate(['recupwd', u ]);
  }
}
